import { noAuthRoute } from '@/router/guards/auth'
import TrackerRemove from '@/views/forms/TrackerRemove.vue'

export default {
  path: '/formulario-retirada-rastreador',
  name: 'form-tracker-remove',
  component: TrackerRemove,
  meta: {
    noAuth: true
  },

  beforeEnter (to, from, next) {
    const canEnter = noAuthRoute()

    if (canEnter) {
      return next(true)
    }

    next('/main')
  }
}
